import { PostOrPage } from '@tryghost/content-api';
import { formatDate } from './helpers';

const authorTitles = ['Written by', 'Edited by', 'Reviewed by'];

export default function GhostPost({ post }: { post: PostOrPage }) {
  const allH2s = Array.from(post.html?.matchAll(/<h2 id="(.*?)">(.*?)<\/h2>/g) || []);

  return (
    <div className="mx-auto w-full max-w-screen-xl px-6 sm:px-8 md:px-12">
      <article className="mt-12 grid grid-cols-1 md:grid-cols-12 md:mt-18 gap-8">
        <div className="col-span-full md:col-span-9 ghost-post">
          <div className="prose md:prose-lg max-w-full prose-headings:font-serif">
            <h1>{post.title}</h1>
            <p className="text-xl">{post.meta_description}</p>
            {(post.updated_at || post.published_at) && (
              <div className="text-gray-500 text-sm">
                Updated on {formatDate(post.updated_at || post.published_at || 0)}
              </div>
            )}
          </div>
          {post.feature_image && (
            <img
              src={post.feature_image}
              alt={post.title}
              width={1200}
              height={600}
              className="mt-8 w-full h-auto"
            />
          )}
        </div>
        <div className="col-span-full md:col-span-3 md:row-span-2">
          <div className="w-full flex md:flex-col gap-8 justify-around">
            {post.authors?.map((author, index) => (
              <div key={author.id} className="flex flex-col gap-2 items-center text-center">
                {author.profile_image && (
                  <img
                    width={56}
                    height={56}
                    src={author.profile_image}
                    alt={author.name}
                    className="w-14 h-14 rounded-full bg-gray-900 ring-2 ring-yellow-600"
                  />
                )}
                <div className="flex flex-col gap-1">
                  <span className="text-xs text-yellow-700/70">{authorTitles[index]}</span>
                  <span className="text-sm md:text-lg text-gray-700">{author.name}</span>
                </div>
              </div>
            ))}
          </div>
          {/* TOC */}
          {allH2s.length > 0 && (
            <div className="w-full text-base md:text-lg flex flex-col gap-4 justify-around mt-16 bg-gray-100 p-6 rounded text-gray-700 md:sticky md:top-4">
              <h3 className="mb-2 font-semibold font-serif text-lg">Table of Contents</h3>
              <ul className="flex flex-col gap-2 items-start text-sm md:text-base list-decimal pl-6">
                {allH2s.map(([, id, h2]) => (
                  <li key={h2} className="hover:underline">
                    <a href={`#${id}`}>{h2}</a>
                  </li>
                ))}
              </ul>
            </div>
          )}
        </div>
        <div className="col-span-full md:col-span-9 ghost-post">
          <div
            className="prose md:prose-lg max-w-full py-12 prose-headings:font-serif"
            dangerouslySetInnerHTML={{ __html: post.html || '' }}
          />
        </div>
      </article>
    </div>
  );
}
